module.exports = __webpack_public_path__ + "static/broom_of_flying-8cacd5589561d32400a709a5c8df6573.jpeg";